import { type DSSCalendarEvent } from "./DSSCalendar.types";

export const mockEvents: DSSCalendarEvent[] = [
  {
    id: "1",
    date: "2026-06-03",
    title: "Sea service period",
    type: "seaService",
  },
  {
    id: "2",
    date: "2026-06-10",
    title: "Watchkeeping duty",
    type: "watchkeeping",
  },
  {
    id: "3",
    date: "2026-06-10",
    title: "Standby",
    type: "standby",
  },
  {
    id: "4",
    date: "2026-06-15",
    title: "Port stay — Monaco",
    type: "portStay",
  },
  {
    id: "5",
    date: "2026-06-22",
    title: "Yard period",
    type: "yard",
  },
  {
    id: "6",
    date: "2026-06-28",
    title: "Sea service period",
    type: "seaService",
  },
  {
    id: "7",
    date: "2026-07-05",
    title: "Watchkeeping duty",
    type: "watchkeeping",
  },
  {
    id: "8",
    date: "2026-07-12",
    title: "Yard period",
    type: "yard",
  },
];
